// @ts-nocheck
const getDaysDifference = (a: Date | string | number, b?: Date | string | number) => {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;

    let date1 = a;
    let date2 = b || new Date();

    if (a instanceof Date) {
        date1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    } else {
        date1 = new Date(date1).getTime();
    }

    if (b instanceof Date) {
        date2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    } else {
        date2 = new Date(date2).getTime();
    }

    return Math.floor((date1 - date2) / _MS_PER_DAY);
};

export default getDaysDifference;
